<template>
  <div class="appcointainer">
    <div class="filters">
      <div class="filtering" v-if="showFiltering">
        <div v-for="provider in providers" :key="provider.name">
          <!-- {{filterProviders}} -->
          <template v-for="(item) in filterProviders">
            <div
              class="filterInput"
              :key="item"
              v-if="item == provider.name"
              :style="[
                provider.color
                  ? { 'background-color': provider.color }
                  : { 'background': '#FFF' },
                provider.fontColor
                  ? { 'color': provider.fontColor }
                  : { 'color': '#000' },
              ]"
            >
              <input
                :name="item"
                :id="item"
                :value="item"
                :placeholder="item"
                type="checkbox"
                v-model="checkedFilter"
                checked
              />
              <label
                :style="provider.color ? background - color : provider.color"
                :for="item"
              >
                {{ provider.title }}
              </label>
            </div>
          </template>
        </div>
      </div>
      <div class="topfil">
        <gmap-autocomplete
          class="filter-container filter-container-search"
          placeholder="Szukaj..."
          :options="{
            fields: ['geometry', 'address_components'],
            strictBounds: true,
          }"
          :select-first-on-enter="true"
          @place_changed="setPlace"
          style="display: inline-block"
        >
        </gmap-autocomplete>
        <img
          :src="locationImg"
          width="30"
          @click="getUserLocation"
          style="cursor: pointer; display: inline-block"
          class="ml-2 mapSearch"
        />
      </div>
      <SiedbarComponent
        v-if="mapison"
        @listclickedpoint="listclickedpoint"
        v-bind:PointList="this.fetchedpoints"
        v-bind:Providers="providers"
        v-bind:PicekdPoint="Object.values(this.pickedPoint)"
      />
    </div>
    <div id="lmap" ref="mapContainer">
      <div class="loader-container" ref="loaderContainer" v-if="showLoader">
        <img
          v-if="showLoader"
          :style="{
            transform: `scale3d(1.2,1.2,1.2)`,
            height: '75px',
            width: '75px',
            transition: 'transform 0.3s ease-in',
            perspective: '600px',
            'perspective-origin': '140% -40%',
          }"
          :src="crown"
          class="pulse"
        />
      </div>
      <div
        class="map_notification-container"
        v-if="!fetchingon && zoomcloser"
        @click="handleNotificationClick"
      >
        <Span v-if="zoomcloser">{{ zoomcloser }}</Span>
      </div>
      <ModalComponent
        v-bind:title="modalTitle"
        v-bind:content="modalContent"
        v-bind:point="modalPoint"
        v-bind:activePoint="pickedPoint"
        v-bind:Providers="providers"
        v-if="isModalVisible && mapison"
        @pickpointmodal.once="pickpointmodal"
        @closespmodal.once="closespmodal"
      />
      <l-map
        v-if="mapison"
        :style="mapstyle"
        :zoom="zoom"
        :center="center"
        @ready="mapready"
        @update:bounds="handleBoundsChange"
        @update:zoom="handleZoom"
        ref="zmap"
        class="zimap"
      >
        <!-- this.$refs.zmap.mapObject.ANY_LEAFLET_MAP_METHOD(); -->
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <template v-for="provider in providers">
          <v-marker-cluster
            :options="{
              iconCreateFunction: clusterIconCreateFunction,
              type: provider.type,
              disableClusteringAtZoom: 16,
            }"
            :key="provider.type"
          >
            <template v-for="(item, index) in fetchedpoints">
              <l-marker
                v-if="item.provider === provider.type"
                :key="item.id"
                :lat-lng="[item.latitude, item.longitude]"
                :visible="item.visible"
                :draggable="item.draggable"
                :options="{ index, provider: item.provider }"
                @click="handlePointClick(item)"
                :ref="item.id"
                :icon="getMarkerIcon(item)"
              >
              </l-marker>
            </template>
          </v-marker-cluster>
        </template>
      </l-map>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { Icon } from "leaflet";
import { fetchProviders, fetchPickupPoints } from "@/services/points";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import { debounce as _debounce } from "lodash";
import ModalComponent from "./components/ModalComponent.vue";
import SiedbarComponent from "./components/SiedbarComponent.vue";
import { axiosInstance } from "@/services/axios.instance";
require("leaflet-modal");

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import {CROWN, GRAY_MARKER, GREEN_MARKER, LOCATION, RED_MARKRER} from "@/utils/images";

const redMarkerShadow = RED_MARKRER;
const greenMarkerShadow = GREEN_MARKER;
const grayMarkerShadow = GRAY_MARKER;
// const crown = require("../src/images/crown.png");
// let loader = null;



export default {
  props: [
    "preselect",
    "maptype",
    "mapheight",
    "providersids",
    "picked_point",
    "runmap",
    "baseurl",
    "eventid",
    "centermap",
    "setzoom",
    "country",
  ],
  watch: {
    country: function(val){
      console.log(val)
      // this.getcountry = val;
      this.getcountry = this.country
      this.map = this.$refs.zmap.mapObject;
      let boundies = this.map.getBounds();
      this.bounds = boundies;
      if (this.mapison) {
        this.updateFirst(boundies);
      }
    },
    checkedFilter: function () {
      this.map = this.$refs.zmap.mapObject;
      let boundies = this.map.getBounds();
      this.bounds = boundies;
      if (this.mapison) {
        this.updateFirst(boundies);
      }
    },
    zoomLevel: function (value) {
      if (value <= this.maxzoomlvl) {
        this.fetchingon = false;
        this.fetchedpoints = [];
      } else {
        this.fetchingon = true;
      }
    },
    preselect: function (neval) {
      if (neval) {
        // console.log(neval);
      }
    },
    centermap: function (newVal) {
      this.$refs.zmap.mapObject.panTo(JSON.parse(newVal));
    },
    runmap: function (newVal) {
      // watch it
      if (newVal === true) {
        this.mapison = true;
      } else {
        this.mapison = false;
      }
    },
    mapCenter: _debounce(function (newVal, oldVal) {
      if (!this.operatorsFetched) return;
      if (newVal !== oldVal) {
        if (newVal.length) {
          this.initialCenter = newVal;
        }
      }
    }, 100),
  },
  data: function () {
    return {
      // uuu: this.$refs.zmap.getZoom(),
      background: '',
      color: '',
      checkedFilter: [],
      fetchedstuff: "", // remove later
      showFiltering: JSON.parse(this.providersids).length > 1 ? true : false,
      filterProviders: JSON.parse(this.providersids),
      zoomcloser: "",
      calculatedDistance: "",
      hideNotification: false,
      map: "",
      appMinimumZoomLevel: 20000,
      modalPoint: [],
      isModalVisible: false,
      modalContent: "",
      modalTitle: "",
      requiredZoom: null,
      maxzoomlvl: 18,
      zoom: this.setzoom ? this.setzoom : 12,
      crown: CROWN,
      showLoader: false,
      fetchingon: true,
      isPointsLoading: false,
      showNotification: false,
      preselected: this.preselect,
      eventname: this.eventid,
      apibaseurl: this.baseurl,
      clickedPoint: [],
      // selectedPoint: [], // depriciated?
      pickedPoint: [],
      mapison: this.runmap === true ? true : false,
      pushpoint: "{}",
      boundiesJSON: JSON.stringify(this.bounds),
      providersidsarray: [],
      mapinfo: [],
      zoomLevel: "",
      mapstyle: "height: " + (this.mapheight ? this.mapheight : "400px"),
      maxheight: this.mapheight ? this.mapheight : "400px",
      value: "inpost",
      type: "PICKUP",
      providers: [],
      displayedProviders: this.checkedFilter,
      getcountry: this.country ? this.country : "UK",
      fetchedpoints: [],
      points: [],
      southWest: "",
      northEast: "",
      bounds: null,
      usedPrePicked: false,
      center: this.centermap
        ? JSON.parse(this.centermap)
        : [51.156962, 17.14875],
      url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
      attribution:
        "&copy; <a href='http://osm.org/copyrighte'>OpenStreetMap</a> contributors",
      showModal: false,
      locationImg: LOCATION,
    };
  },
  name: "App",
  components: {
    ModalComponent,
    SiedbarComponent,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    LMap,
    LTileLayer,
    LMarker,
  },
  methods: {
    getLonLat(xtile, ytile, zoom) {
      let n = 2 ** zoom;
      let lon_deg = (xtile / n) * 360.0 - 180.0;
      let lat_deg = this.rad2deg(
        Math.atan(Math.sinh(Math.PI * (1 - (2 * ytile) / n)))
      );
      return { lon_deg, lat_deg };
    },
    rad2deg(radians) {
      let pi = Math.PI;
      return radians * (180 / pi);
    },
    deg2rad(degrees) {
      let pi = Math.PI;
      return degrees * (pi / 180);
    },
    getTileNumber(lat, lon, zoom) {
      let xtile = ((lon + 180) / 360) * 2 ** zoom;
      let ytile =
        ((1 -
          Math.log(
            Math.tan(this.deg2rad(lat)) + 1 / Math.cos(this.deg2rad(lat))
          ) /
            Math.PI) /
          2) *
        2 ** zoom;
      return { xtile, ytile };
    },
    getZoomBounds(lat, lng, zoom) {
      const width = this.$refs.zmap.$el.clientWidth;
      const height = this.$refs.zmap.$el.clientHeight;
      const tile_size = 256;

      let { xtile, ytile } = this.getTileNumber(lat, lng, zoom);
      const xtile_s = (xtile * tile_size - width / 2) / tile_size;
      const ytile_s = (ytile * tile_size - height / 2) / tile_size;
      const xtile_e = (xtile * tile_size + width / 2) / tile_size;
      const ytile_e = (ytile * tile_size + height / 2) / tile_size;

      let coords_s = this.getLonLat(xtile_s, ytile_s, zoom);
      let coords_e = this.getLonLat(xtile_e, ytile_e, zoom);
      return {
        _northEast: { lat: coords_s.lat_deg, lng: coords_e.lon_deg },
        _southWest: { lat: coords_e.lat_deg, lng: coords_s.lon_deg },
      };
    },
    calculateDistanceBetweenCoordinates(
      latitudeFrom,
      longitudeFrom,
      latitudeTo,
      longitudeTo
    ) {
      const earthRadius = 6371000;
      // convert from degrees to radians
      let latFrom = this.deg2rad(latitudeFrom);
      let lonFrom = this.deg2rad(longitudeFrom);
      let latTo = this.deg2rad(latitudeTo);
      let lonTo = this.deg2rad(longitudeTo);
      let latDelta = latTo - latFrom;
      let lonDelta = lonTo - lonFrom;
      let angle =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(latDelta / 2), 2) +
              Math.cos(latFrom) *
                Math.cos(latTo) *
                Math.pow(Math.sin(lonDelta / 2), 2)
          )
        );
      return angle * earthRadius;
    },
    calculateDistance(CoordinateFrom, CoordinateTo) {
      return this.calculateDistanceBetweenCoordinates(
        CoordinateFrom.lat,
        CoordinateFrom.lng,
        CoordinateTo.lat,
        CoordinateTo.lng
      );
    },
    setPlace(val) {
      this.$refs.zmap.mapObject.flyTo(
        [val.geometry.location.lat(), val.geometry.location.lng()],
        16
      );
    },
    handleNotificationClick() {
      this.$refs.zmap.mapObject.setZoom(
        this.$refs.zmap.mapObject.getZoom() + 2
      );
    },
    mapready(mapinfo) {
      this.map = this.$refs.zmap.mapObject;
      let boundies = mapinfo.getBounds();
      this.bounds = boundies;
      this.checkedFilter = JSON.parse(this.providersids);
      if (this.mapison) {
        this.updateFirst(boundies);
      }
      const lat = this.map.getCenter().lat;
      const lng = this.map.getCenter().lng;
      for (let i = this.map.getMinZoom(); i <= this.map.getMaxZoom(); i++) {
        let zoomedBound = this.getZoomBounds(lat, lng, i);
        const distance =
          this.calculateDistance(
            zoomedBound._northEast,
            zoomedBound._southWest
          ) > this.appMinimumZoomLevel;
        if (!distance) {
          this.requiredZoom = i;
          break;
        }
      }
    },
    clusterIconCreateFunction(cluster) {
      let child = cluster.getAllChildMarkers()[0];
      let childCount = cluster.getChildCount();

      let c = " marker-cluster-";
      if (childCount < 10) {
        c += "small";
      } else if (childCount < 100) {
        c += "medium";
      } else {
        c += "large";
      }

      const index = this.providers.indexOf(
        this.providers.find(
          (element) =>
            `${element.type}`.toLowerCase() ===
            `${child.options.provider}`.toLowerCase()
        )
      );
      const margin = index * 30;
      let icon = this.providers.find(
        (element) =>
          `${element.type}`.toLowerCase() ===
          `${child.options.provider}`.toLowerCase()
      ).image;
      return new L.DivIcon({
        html:
          '<div style="display: flex; align-content:center; align-items:center; justify-content:center; ' +
          "width: 50px; height: 50px; background-size: 100% 100%; margin-left:-" +
          margin +
          "px;" +
          "background-image: linear-gradient( rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)), url(" +
          icon +
          '); text-shadow: white 0px 0px 10px; " ><span style="font-size: 20px;\n' +
          '    font-weight: bold; color: white">' +
          childCount +
          "</span></div>",
        className: "custom-marker-cluster " + "marker-cluster" + c,
        iconSize: new L.Point(50, 50),
      });
    },

    boundsUpdated(bounds) {
      this.bounds = bounds;
    },

    handleZoom(zoomLevel) {
      this.calculatedDistance = zoomLevel;
      this.$emit("map-zoomed", zoomLevel);
      this.showLoader = true;
      if (zoomLevel <= 14) {
        // this.hideNotification = false;
      }
      if (zoomLevel >= this.maxzoomlvl) {
        // this.showLoader = true;
      }
      if (zoomLevel) {
        this.zoomLevel = zoomLevel;
        // this.updateFirst(this.$refs.zmap.mapObject.getBounds());
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },

    getUserLocation() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.$refs.zmap.mapObject.panTo([
            position.coords.latitude,
            position.coords.longitude,
          ]);
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    

    setPickedPoint(item) {
      // console.log("Whia! Bom bom!");
      this.pickedPoint = item;
      this.point = item;
      this.pushpoint = JSON.stringify(item);
      document.getElementById(this.eventid).value = JSON.stringify(item);
      this.$emit(this.eventname);
      this.clickedPoint = [];

      /* eslint-disable */
      if(typeof SpMapWidget !== 'undefined'){
        SpMapWidget.onSelect(item);
      }
      /* eslint-enable */
    },
    clickedsc() {
      // console.log("hurray" + JSON.stringify(item));
    },
    closespmodal() {
      this.modalContent = "";
      this.isModalVisible = false;
      this.modalTitle = "";
    },

    listclickedpoint(event, point) {
      this.handlePointClick(point);
    },

    pickpointmodal(event, point) {
      this.setPickedPoint(point);
      this.isModalVisible = false;
    },

    handlePointClick(item) {
      this.clickedPoint = item;
      this.$refs.zmap.mapObject.flyTo({
        lat: item.latitude,
        lng: item.longitude,
      });

      // open new modal
      this.modalContent = "<p>" + item.description + "</p>";
      this.isModalVisible = true;
      this.modalTitle = item.title;
      this.modalPoint = item;
    },

    getMarkerIcon(value) {
      // console.log('creating icon from: ' + JSON.stringify(value))
      let icon;
      // console.log('check id: ' + value.id)
      if (!value.clicked) {
        icon = L.icon({
          iconUrl: this.providers.find(
            (element) =>
              `${element.type}`.toLowerCase() ===
              `${value.provider}`.toLowerCase()
          ).image,
          iconSize: [35, 35],
          iconAnchor: [17, 60],
          shadowUrl: redMarkerShadow,
          shadowSize: [70, 70],
          shadowAnchor: [34, 67],
        });
      }
      if (value.id === this.clickedPoint.id) {
        icon = L.icon({
          iconUrl: this.providers.find(
            (element) =>
              `${element.type}`.toLowerCase() ===
              `${value.provider}`.toLowerCase()
          ).image,
          iconSize: [35, 35],
          iconAnchor: [17, 60],
          shadowUrl: grayMarkerShadow,
          shadowSize: [70, 70],
          shadowAnchor: [34, 67],
        });
      }
      if (value.id === this.pickedPoint.id) {
        icon = L.icon({
          iconUrl: this.providers.find(
            (element) =>
              `${element.type}`.toLowerCase() ===
              `${value.provider}`.toLowerCase()
          ).image,
          iconSize: [35, 35],
          iconAnchor: [17, 60],
          shadowUrl: greenMarkerShadow,
          shadowSize: [70, 70],
          shadowAnchor: [34, 67],
        });
      }
      return icon;
    },
    updateBells(points) {
      this.fetchedpoints = points;
      if (this.preselect && points) {
        // console.log('mama' + points.id + this.preselect)
        points.forEach((value) => {
          // console.log(value.id + " - " + this.preselect);
          if (value.id == this.preselect && !this.usedPrePicked) {
            this.usedPrePicked = true;
            this.setPickedPoint(value);
          }
        });
      }
    },
    updateProviders(prov) {
      this.providers = prov;
    },

    updateFirst(bounds) {
      // console.log(JSON.stringify(this.checkedFilter));
      if (this.mapison) {
        this.southWest = {
          latitude: bounds._southWest.lat,
          longitude: bounds._southWest.lng,
        };
        this.northEast = {
          latitude: bounds._northEast.lat,
          longitude: bounds._northEast.lng,
        };
        let maptype = this.maptype;
        let params = {
          type: maptype,
          country: this.getcountry,
          providers: JSON.stringify(this.checkedFilter),
          southWest: this.southWest,
          northEast: this.northEast,
        };
        this.showLoader = true;
        const CancelToken = axiosInstance.CancelToken;
        this.source = CancelToken.source();
        fetchPickupPoints(this.apibaseurl, params)
          .then((value) => {
            // console.log(JSON.stringify(value) + ' ' + JSON.stringify(this.fetchedpoints))
            if (JSON.stringify(value) != JSON.stringify(this.fetchedpoints)) {
              this.updateBells(value);
              this.zoomcloser = false;
              this.hideNotification = true;
            }
            this.showLoader = false;
          })
          .catch((error) => {
            this.showLoader = false;
            console.error(error.error.message);
            this.zoomcloser = error.error.message;
          });
      }
    },
    handleBoundsChange(bounds) {
      this.bounds = bounds;
      this.updateFirst(bounds);
    },
  },
  beforeCreate() {},
  created() {
    fetchProviders(this.apibaseurl).then((value) => {
      this.updateProviders(value);
    });

    // setTimeout(() => {
    //   this.updateFirst(this.bounds);
    // }, 500);
  },
  mounted: function () {
    this.zoomLevel = this.$refs.zmap.mapObject.getZoom();
    if (this.zoomLevel < 12) {
      // loader = this.$preloader.show({
      //   isFullPage: false,
      //   container: this.$refs.loaderContainer,
      //   height: "auto",
      //   width: "auto",
      //   zIndex: 500,
      //   backgroundColorProp: "none",
      // });
    }
  },
};
</script>

<style>
/* .mapcontainer {
  position: relative;
}
*/
.topfil {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.topfil .filter-container {
  width: 100%;
}
.spsidebar {
  margin-top: 20px;
}
.filters {
  width: 25%;
}
.appcointainer {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: row;
  width: 100%;
}

#lmap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 75%;
}
.map_notification-container {
  position: absolute;
  z-index: 999;
  display: block;
  border-radius: 20%;
  background: linear-gradient(45deg, #ff0077, #f29d01);
  /* background: red; */
  color: white;
  padding: 15px 25px;
  border-radius: 20px;
}

.map_notification-container:hover {
  cursor: pointer;
}

.map_notification-container span {
  /* position: absolute;
  z-index: 999;
  display: block;
  border-radius: 20%;
  background: linear-gradient(45deg, #ff0077, #f29d01);
  color: white;
  padding: 15px 25px;
  border-radius: 20px; */
}
.loader-container {
  width: 120px;
  height: 120px;
  z-index: 9999;
  position: absolute;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
img.leaflet-marker-icon {
  border-radius: 50% !important;
}

.leaflet-modal {
  visibility: hidden;
  pointer-events: none;
}
.leaflet-modal .overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  background: #222222;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: 10001;
  -webkit-transition: opacity 0.25s linear;
  -o-transition: opacity 0.25s linear;
  transition: opacity 0.25s linear;
}
.leaflet-modal .close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  filter: alpha(opacity=20);
}
.leaflet-modal .close:hover {
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.leaflet-modal .modal {
  display: block;
  left: auto;
  margin-right: auto;
  margin-left: auto;
  margin-top: auto;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 10002;
  overflow: auto;
  height: 100%;
}
.leaflet-modal .modal-content {
  padding: 15px;
  background: #ffffff;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  outline: 0;
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 100%; */
  margin-bottom: 40px;
  max-width: 450px;
  -webkit-transition: margin 0.3s linear;
  -o-transition: margin 0.3s linear;
  transition: margin 0.3s linear;
}
.leaflet-modal.show {
  width: 100%;
  height: 100%;
  visibility: visible;
  pointer-events: visible;
}
.leaflet-modal.show .modal-content {
  margin-top: 40px;
}
.leaflet-modal.show .overlay {
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.pulse {
  animation: pulse 2s infinite;
  -webkit-animation-name: pulse;
  animation-name: pulse;
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.filters {
  padding: 20px;
}
div.pac-container {
  z-index: 99999999999 !important;
}

.filtering {
  display: flex;
  margin-bottom: 10px;
}
.filterInput {
  margin: 5px 10px 0 0;
  /* border: 1px solid #000; */
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 10px;
}
.filterInput:hover, .filterInput > input:hover, .filterInput > label:hover {
  cursor: pointer;
}

.filterInput > input {
  margin-right: 5px;
}
.filterInput > label {
  margin-bottom: 0;
}
</style>
